import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CredentialsCancelJustifyComponent } from '../credentials/credentials-cancel-justify/credentials-cancel-justify.component';
import { CpfSharedService } from 'src/app/services/cpf-shared.service';
import { Subject, takeUntil } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import {
  DynamicDialogRef,
  DynamicDialogConfig,
  DialogService,
} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-yesorno-dialog',
  standalone: true,
  imports: [ButtonModule],
  providers: [DialogService],
  template: `
    <div class="dialog-content">
      {{ data.message }}
    </div>
    <div class="dialog-actions">
      <button pButton type="button" label="Não" class="p-button-text" (click)="onCancel()"></button>
      <button pButton type="button" label="Sim" (click)="onConfirm()"></button>
    </div>
  `,
  styles: [`
    .dialog-content {
      padding: 12px 0 16px;
    }

    .dialog-actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
    }

    :host ::ng-deep .p-dialog {
      border-radius: 5px;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YesornoDialogComponent implements OnDestroy {
  private destroyed$ = new Subject<void>();
  private isHandled = false;

  constructor(
    private cpfSharedService: CpfSharedService,
    private dialogService: DialogService,
    public dialogRef: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private router: Router
  ) {
    this.dialogConfig.closable = false;
  }

  get data(): { type: string; credentialId: number; message: string } {
    return this.dialogConfig.data;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    // console.log('YesornoDialogComponent destruído');
  }

  onConfirm(): void {
    if (this.isHandled) return;
    this.isHandled = true;

    // console.log('Confirmado cadastro de CPF');
    
    switch (this.data.type) {
      case 'cpf':
        // Fechar e navegar de forma segura
        this.dialogRef.close({ confirmed: true });
        setTimeout(() => {
          this.router.navigate(['/home/people']);
        }, 100);
        break;
      case 'cancelCredential':
        this.dialogRef.close({ confirmed: true });
        setTimeout(() => {
          this.openCredentialsCancelJustify(this.data.credentialId);
        }, 100);
        break;
      default:
        this.dialogRef.close({ confirmed: true });
    }
  }

  onCancel(): void {
    if (this.isHandled) return;
    this.isHandled = true;

    // console.log('Cancelado cadastro de CPF');
    
    this.dialogRef.close({ confirmed: false });
    
    setTimeout(() => {
      this.cpfSharedService.clearCpf();
      this.cpfSharedService.clearRecipientCpf();
      this.cpfSharedService.clearApplicantCpf();
    }, 100);
  }

  openCredentialsCancelJustify(credentialId: number): void {
    const ref = this.dialogService.open(CredentialsCancelJustifyComponent, {
      header: 'Justificativa de Cancelamento',
      width: '600px',
      data: { credentialId },
      closable: true,
    });

    if (ref) {
      ref.onClose.pipe(takeUntil(this.destroyed$)).subscribe(() => {
        // console.log('CredentialsCancelJustifyComponent fechado');
      });
    }
  }
}